(function () {
  angular.module("akitabox.ui.dialogs.externalWorkOrderLink", [
    "akitabox.core.constants",
    "akitabox.core.services.flag",
    "akitabox.core.services.user",
    "akitabox.core.services.note",
    "akitabox.core.toast",
    "ngMaterial",
  ]);
})();
